import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdownWithAnchors from '@/components/VueMarkdownWithAnchors.vue';
import CardSet from '@/components/CardSet.vue';
import Loading from '@/components/Loading.vue';
const deploymentsModule = namespace('starshipSizes');
const blobsModule = namespace('blobs');
let StarshipSizes = class StarshipSizes extends Vue {
    constructor() {
        super(...arguments);
        this.mainBlob = '';
        this.variant = '';
        this.spaceStation = '## Variant: Space Stations';
    }
    async created() {
        await this.fetchStarshipBlob('Starships');
        this.fetchStarshipSizes();
        const split = this.starshipBlobs['Starships'].split(this.spaceStation);
        this.mainBlob = split[0];
        this.variant = split[1];
    }
    get starshipSizesWithLinks() {
        return this.starshipSizes.map(starshipSize => ({
            ...starshipSize,
            to: `starshipSizes/${starshipSize.name}`
        }));
    }
    showSaves(saves) {
        if (saves.length === 3) {
            return `${saves.slice(0, 2).join(', ')} or ${saves[2]}`;
        }
        else {
            return saves.join(' or ');
        }
    }
};
__decorate([
    deploymentsModule.State
], StarshipSizes.prototype, "starshipSizes", void 0);
__decorate([
    deploymentsModule.Action
], StarshipSizes.prototype, "fetchStarshipSizes", void 0);
__decorate([
    blobsModule.State
], StarshipSizes.prototype, "starshipBlobs", void 0);
__decorate([
    blobsModule.Action
], StarshipSizes.prototype, "fetchStarshipBlob", void 0);
StarshipSizes = __decorate([
    Component({
        components: {
            VueMarkdownWithAnchors,
            Loading,
            CardSet
        }
    })
], StarshipSizes);
export default StarshipSizes;
